export interface BaseFullEmployeeFormDomainParams {
  groupId: string;
  periodId: string;
  subscriberId?: string;
  activeTabId?: string;
}

export enum TabId {
  EMPLOYEE_PROFILE = 'employee-profile',
  DEPENDENTS = 'dependents',
}

export enum ElectionsTabId {
  ELECTIONS = 'elections',
}

export type TabIdWithElections = TabId | ElectionsTabId;
